module.exports = "<div block-ui=\"contactList\">\r\n  <div class=\"list-group\">\r\n    <a ui-sref=\"contactView({contactId: c.contactId})\" class=\"list-group-item\" ng-repeat=\"c in $ctrl.contacts\">\r\n      {{c.name}}\r\n    </a>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/dashboard/recentContacts/recentContacts.html
// module id = 1464
// module chunks = 0